import { render, staticRenderFns } from "./TeacherCrud.vue?vue&type=template&id=a4cdb668&"
import script from "./TeacherCrud.vue?vue&type=script&lang=js&"
export * from "./TeacherCrud.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCrud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports